import { BgEffectLayer } from "@wa/widgets/bg-effect";

/**
 * Animeeritud mesh(macOS) taust - sama efekt, mida page-builder pakub
 * (`bgEffect: "mesh"`), nii et staff-CRM on platvormiga visuaalselt ühtne.
 * Brändivärvid CSS-muutujatest → kohaneb teemaga (hele/tume). Fikseeritud terve
 * vaateava taha (`-z-10`); sisu istub kõrgemal.
 */
export function AppBackground({ intensity = 60 }: { intensity?: number }) {
  return (
    <div aria-hidden className="fixed inset-0 -z-10 overflow-hidden bg-background">
      <BgEffectLayer
        props={{
          bgType: "solid",
          bgEffect: "mesh",
          bgEffectColor1: "var(--color-primary)",
          bgEffectColor2: "var(--color-primary-2)",
          bgEffectColor3: "var(--color-accent-brand)",
          bgEffectSpeed: 24,
          bgEffectBlur: 90,
          bgEffectIntensity: intensity,
          bgEffectAnimate: true,
        }}
      />
    </div>
  );
}
